import React from 'react';

import { useEffect } from 'react';

export const NaverSolutionStart = () => {
  useEffect(() => {
    window.location.replace('https://app.sellerbox.io');
  }, []);
  return <div></div>;
};
